import React, {useEffect, useState} from 'react';
import axios from "../../../helpers/axios";
import LoadingButton from "../../base/components/loadingButton";
import {typeTranslate} from "./registersReviceTabs";
import _ from "lodash";
import {GROUP_ROUTE_TYPE} from "./GroupForm";

const AddRowsToGoogleButton = ({info, list, textTitle, variant, disabledButton, cb}) => {
  const [loading, setLoading] = useState(false)
  const [title, setTitle] = useState(textTitle)
  const isDone = title === 'Ряды успешно добавлены!'

  const sendRowsForGoogle = (list) =>{
    if (loading || isDone || disabledButton) return
    setLoading(true)
    cb && cb('start')
    const generateDataByOneList = (list) =>{
      return {
        counterparty: list.name,
        tableData: list.tableData.map(row=>{
          // const paxCol = row.itemType === "BANK" ? "Банк" : row.paxName
          let description = row.description
          if(row.itemType === "TKT") description = row[_.find(GROUP_ROUTE_TYPE, {value: info.group.routeType})?.nameInObject] || row.description
          const tNumber = `${row.itemNumber}${row.refund && row.itemType !== "SRV" ? '-В' : ''}`
          const needArray = [row.issueDate,typeTranslate[row.itemType],row.paxName,tNumber,description,row.total,row.itemDate]
          if(row.itemType === "BANK" || row.itemType === "CASH"|| row.itemType === "TAX"){
            needArray.push('')
            needArray.push(row.counterpartyCode)
          }
          needArray.push(row.krsTotal)
          return needArray
        })
      }
    }
    const sendInfo = {
      sheetId : info.group.googleSheetId
    }
    if(!!list){
      sendInfo.data =[generateDataByOneList(list)]
    }else{
      sendInfo.data = info.data.past.map(list=>{
        return generateDataByOneList(list)
      })
    }
    axios.post('/api/racoon/revise/group/addRowsToSheets', sendInfo)
      .then(()=>{
        setTitle('Ряды успешно добавлены!')
        cb && cb(list ? 'sheet-done' : 'all-done')
      })
      .catch(()=>{
        cb && cb('error')
      })
      .finally(()=>setLoading(false))
  }


  useEffect(() => {
    setTitle(textTitle)
  }, [info]);
  return (
    <LoadingButton loading={loading}
                   size={'sm'}
                   disabled={loading || isDone || disabledButton}
                   onClick={()=>sendRowsForGoogle(list)}
                   variant={variant || 'primary'}
                   title={title}/>
  );
};

export default AddRowsToGoogleButton;
